import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';

@Pipe({ name: 'toObservable', standalone: true })
export class ToObservablePipe implements PipeTransform {
  transform(value: string | Observable<string>): Observable<string> {
    return isObservable(value) ? value : of(value);
  }
}
